import { render, staticRenderFns } from "./PlayerActions.vue?vue&type=template&id=3ad0a144"
import script from "./PlayerActions.vue?vue&type=script&lang=js"
export * from "./PlayerActions.vue?vue&type=script&lang=js"
import style0 from "./PlayerActions.vue?vue&type=style&index=0&id=3ad0a144&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports